import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthProvider';
import { ShoppingListProvider } from './context/ShoppingListProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ShoppingListProvider>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </ShoppingListProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);